import { render } from "./CustomerImage.vue?vue&type=template&id=d2a2d100"
import script from "./CustomerImage.vue?vue&type=script&lang=js"
export * from "./CustomerImage.vue?vue&type=script&lang=js"

import "./CustomerImage.vue?vue&type=style&index=0&id=d2a2d100&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__